export default __webpack_public_path__ + "static/media/delete_black.8d721dac.svg";